import Select from 'react-select';
import styled from 'styled-components/macro';

export const MultiSelect = styled(Select)<{ error?: string; hideValue?: boolean }>`
  .true__control {
    border: 1px solid;
    border-color: ${({ theme, error }) =>
      error === 'hasError' ? theme.colors.negative_dark : theme.colors.black_10};
  }
  .true__multi-value {
    display: ${({ hideValue }) => (hideValue ? 'none' : 'flex ')};
    border-radius: 4px;

    background-color: ${({ theme }) => theme.colors.primary_80};

    :hover {
      background-color: ${({ theme }) => theme.colors.primary_dark};
      cursor: pointer;
      > .true__multi-value__remove svg path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }

  .true__multi-value__remove {
    color: ${({ theme }) => theme.colors.black_20};
    :hover {
      background-color: ${({ theme }) => theme.colors.transparent};
    }
  }

  .css-6q0nyr-Svg {
    width: 1rem;
    height: 1rem;
  }

  .true__multi-value__label {
    color: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.fontSize.xxs};
    font-family: ${({ theme }) => theme.fontFamily.semiBold};
    line-height: ${({ theme }) => theme.lineHeight.one_1};
    letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  }

  .true__indicator-separator {
    display: none;
  }
`;
